(function () {
  var COOKIE_KEY = 'machu_cookie_consent_v1';

  function parseJSON(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  /**
   * Shopifys Consent-API liegt nicht automatisch bereit - sie muss ueber
   * loadFeatures nachgeladen werden.  Fehlte dieser Aufruf, lief
   * setTrackingConsent wirkungslos ins Leere und die Zustimmung wurde nie
   * an Shopify und Google weitergereicht.
   */
  function mitPrivacy(callback) {
    var shop = window.Shopify;
    if (shop && shop.customerPrivacy &&
        typeof shop.customerPrivacy.setTrackingConsent === 'function') {
      callback(shop.customerPrivacy);
      return;
    }
    if (!shop || typeof shop.loadFeatures !== 'function') return;

    shop.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fehler) {
      if (fehler) return;
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.setTrackingConsent === 'function') callback(privacy);
    });
  }

  function setTrackingConsent(consent) {
    var payload = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      preferences: !!consent.preferences,
      sale_of_data: false,
      sale_of_data_allowed: false
    };

    mitPrivacy(function (privacy) {
      try {
        privacy.setTrackingConsent(payload, function () {});
      } catch (error) {
        // no-op on unsupported storefront contexts
      }
    });
  }

  function hatGespeicherteZustimmung() {
    return !!localStorage.getItem(COOKIE_KEY);
  }

  function initEntryPopups() {
    var cookiePopup = document.querySelector('[data-cookie-popup]');
    if (!cookiePopup) return;

    var cookieSettings = cookiePopup.querySelector('[data-cookie-settings]');
    var analyticsInput = cookiePopup.querySelector('[data-consent-analytics]');
    var marketingInput = cookiePopup.querySelector('[data-consent-marketing]');
    var preferencesInput = cookiePopup.querySelector('[data-consent-preferences]');

    function showCookiePopup() {
      cookiePopup.classList.add('is-visible');
      cookiePopup.setAttribute('aria-hidden', 'false');
    }

    function hideCookiePopup() {
      cookiePopup.classList.remove('is-visible');
      cookiePopup.setAttribute('aria-hidden', 'true');
    }

    function saveConsent(consent) {
      localStorage.setItem(COOKIE_KEY, JSON.stringify(consent));
      setTrackingConsent(consent);
      hideCookiePopup();
    }

    var acceptAllButton = cookiePopup.querySelector('[data-cookie-accept-all]');
    var acceptNecessaryButton = cookiePopup.querySelector('[data-cookie-accept-necessary]');
    var openSettingsButton = cookiePopup.querySelector('[data-cookie-open-settings]');
    var saveSettingsButton = cookiePopup.querySelector('[data-cookie-save-settings]');

    if (acceptAllButton) {
      acceptAllButton.addEventListener('click', function () {
        saveConsent({ analytics: true, marketing: true, preferences: true });
      });
    }

    if (acceptNecessaryButton) {
      acceptNecessaryButton.addEventListener('click', function () {
        saveConsent({ analytics: false, marketing: false, preferences: false });
      });
    }

    if (openSettingsButton && cookieSettings) {
      openSettingsButton.addEventListener('click', function () {
        var isHidden = cookieSettings.hasAttribute('hidden');
        if (isHidden) {
          cookieSettings.removeAttribute('hidden');
        } else {
          cookieSettings.setAttribute('hidden', '');
        }
      });
    }

    if (saveSettingsButton) {
      saveSettingsButton.addEventListener('click', function () {
        saveConsent({
          analytics: analyticsInput ? analyticsInput.checked : false,
          marketing: marketingInput ? marketingInput.checked : false,
          preferences: preferencesInput ? preferencesInput.checked : false
        });
      });
    }

    var existingConsent = parseJSON(localStorage.getItem(COOKIE_KEY));
    if (existingConsent) {
      setTrackingConsent(existingConsent);
      return;
    }

    if (!hatGespeicherteZustimmung()) {
      showCookiePopup();
      // Shopify kann melden, dass in dieser Region kein Banner noetig ist.
      // Das steht erst nach dem Nachladen der API fest - dann ggf. wieder ausblenden.
      mitPrivacy(function (privacy) {
        if (typeof privacy.shouldShowBanner !== 'function') return;
        try {
          if (!privacy.shouldShowBanner()) hideCookiePopup();
        } catch (error) {
          // Banner bleibt sichtbar - im Zweifel fuer die Zustimmungspflicht
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEntryPopups);
  } else {
    initEntryPopups();
  }
})();
